import { render, staticRenderFns } from "./profile-side-modal.vue?vue&type=template&id=7d13137a&scoped=true"
import script from "./profile-side-modal.vue?vue&type=script&lang=js"
export * from "./profile-side-modal.vue?vue&type=script&lang=js"
import style0 from "./profile-side-modal.vue?vue&type=style&index=0&id=7d13137a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d13137a",
  null
  
)

export default component.exports